// extracted by mini-css-extract-plugin
module.exports = {"title":"latestStrainTable_title__1hG2M","fullWidth":"latestStrainTable_fullWidth__1PQcP","tooltip":"latestStrainTable_tooltip__13iZS"};